<script>
    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            editData() {return this.$store.getters.PROMPT_DATA_EDIT}
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'PROMPT_DATA_EDIT_UPDATE', 'CHECK_PROMPT_EDIT', isCheckBox
                );
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            :value="editData['name']"
            @change="updateData($event, 'name')"
            class="right_input mt_5 mb_10"
        >
        <label>Prompt Body:</label>
        <textarea
            :value="editData['body']"
            @change="updateData($event, 'body')"
            class="right_input mt_5 mb_10"
        ></textarea>
        <label>Prompt Exclude Words:</label>
        <textarea
            :value="editData['promt_exclude_words']"
            @change="updateData($event, 'promt_exclude_words')"
            class="right_input mt_5 mb_10"
        ></textarea>
        <label>Programm Exclude Words:</label>
        <textarea
            :value="editData['programm_exclude_words']"
            @change="updateData($event, 'programm_exclude_words')"
            class="right_input mt_5"
        ></textarea>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>